import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import SelectAziende from './SelectAziende';
import CreaMenu from './CreaMenu';
import CreaPacchetto from './CreaPacchetto';
import { BASE_URL } from './config';
import CreaTradizioni from './CreaTradizioni';

const ModificaEvento = ({ idEvento, evento: initialEvento, onBack }) => {
  const componentId = useRef(Math.random().toString(36).substring(7));
  const [selectedAziendaId, setSelectedAziendaId] = useState('');
  const [formData, setFormData] = useState({
    titolo: '',
    descrizione: '',
    dataInizio: '',
    dataFine: '',
    campiMenu: [],
    categorie: [],
    prezzo: 0,
    immagineCopertina: null,
    idEvento: '',
    tipologiaEvento: '',
    categoriaEvento: '',
    posti: 0,
    fileName: null,
    fasceOrarie: [],
    idAzienda: null,
  });

  // Fetch evento all’inizio o quando cambia idEvento
  useEffect(() => {
    const fetchEvento = async (idEvento) => {
      if (!idEvento) return;

      const headers = new Headers({
        'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
        'Content-Type': 'application/json',
      });

      try {
        const response = await fetch(`${BASE_URL}/eventi/admin/evento/${idEvento}`, { headers });
        const eventoData = await response.json();
        console.log(`[${componentId.current}] Evento caricato:`, eventoData);

        setFormData((prev) => ({
          ...prev,
          ...eventoData,
          idEvento,
          idAzienda: eventoData.idAzienda || prev.idAzienda,
        }));
      } catch (error) {
        console.error('Errore caricamento evento:', error);
      }
    };

    fetchEvento(idEvento);
  }, [idEvento]);

  const handleSelectedAzienda = useCallback((aziendaId) => {
    setSelectedAziendaId(aziendaId);
    console.log(`[${componentId.current}] Azienda selezionata:`, aziendaId);
  }, []);

  // Funzione per preparare payload da inviare al backend
  function preparaInsertEventoDTO(data) {
    return {
      titolo: data.titolo,
      descrizione: data.descrizione,
      dataInizio: data.dataInizio ? data.dataInizio.substring(0, 10) : null,
      dataFine: data.dataFine ? data.dataFine.substring(0, 10) : null,
      prezzo: Number(data.prezzo) || 0,
      immagineCopertina: data.immagineCopertina || null,
      categorie: data.categorie || [],
      fasceOrarie: (data.fasceOrarie || []).map((f) => f.replace(/\s*-\s*/, '-')),
      campiMenu: (data.campiMenu || []).map((campo) => ({
        categoria: campo.nome,
        options: campo.descrizione
          ? campo.descrizione.split(',').map((s) => s.trim())
          : [],
      })),
      posti: Number(data.posti) || 0,
      fileName: data.fileName || null,
      idAzienda: data.idAzienda || null,
      tipologiaEvento: data.tipologiaEvento || null,
      idEvento: data.idEvento || null,
    };
  }

  // Funzione submit stabile con useCallback
  const handleSubmit = useCallback(
    (dataDaInviare) => {
      console.log(`[${componentId.current}] Submit con dati:`, dataDaInviare);

      const payload = preparaInsertEventoDTO({
        ...formData,
        ...dataDaInviare,
        idAzienda: selectedAziendaId || formData.idAzienda,
      });

      fetch(`${BASE_URL}/eventi/admin/${payload.idEvento}`, {
        method: 'PUT',
        headers: {
          'Authorization': 'Bearer ' + sessionStorage.getItem('accessToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) throw new Error('Errore durante aggiornamento evento');
          return res.json();
        })
        .then((data) => {
          console.log(`[${componentId.current}] Evento aggiornato:`, data);
          // Qui potresti resettare formData o notificare successo
        })
        .catch((error) => {
          console.error('Errore aggiornamento evento:', error);
        });
    },
    [formData, selectedAziendaId]
  );

  // Calcola il componente da renderizzare in base a categoriaEvento
  const componenteForm = useMemo(() => {
    if (formData.categoriaEvento === 'food') {
      return <CreaMenu onFormSubmit={handleSubmit} azienda={selectedAziendaId} evento={formData} />;
    }
    if (formData.categoriaEvento === 'tradition') {
      return <CreaTradizioni onFormSubmit={handleSubmit} azienda={selectedAziendaId} evento={formData} />;
    }
    if (formData.categoriaEvento === 'transport' || formData.categoriaEvento === 'solemare') {
      return <CreaPacchetto onFormSubmit={handleSubmit} azienda={selectedAziendaId} evento={formData} />;
    }
    return null;
  }, [formData.categoriaEvento, selectedAziendaId, handleSubmit, formData]);

  return (
    <div className="main-content">
      <center>
        <SelectAziende onSelectedData={handleSelectedAzienda} />
      </center>
      {formData.tipologiaEvento && (
        <p>
          <b>Tipologia Evento:</b> {formData.tipologiaEvento}
        </p>
      )}
      {componenteForm}
    </div>
  );
};

export default ModificaEvento;
